module.exports = "/_next/static/images/faec207210a2fc92744f40d4abcfde69-kit-ui.png.webp";